import {ChangeDetectionStrategy, Component, inject, signal, WritableSignal} from "@angular/core";
import {onEach} from '../../utils/observable-utils';
import {NotificationService} from "../notification.service";
import {FooterMessageComponent} from "../message/footer-message.component";

@Component({
    selector: "woa-footer-messages",
    templateUrl: "footer-messages.component.html",
    imports: [
        FooterMessageComponent
    ],
    styleUrl: "./footer-messages.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterMessagesComponent {
    public notificationService: NotificationService = inject(NotificationService);

    public readonly showDynamicMessages: WritableSignal<boolean> = signal<boolean>(false);

    constructor() {
        onEach(this.notificationService.footerMessagesChanged$, () => {
            this.showDynamicMessages.set(true);
        });
    }
}
